<button
  (click)="buttonClicked()"
  [ngClass]="buttonContent.type || buttonTypes.Primary"
  [ngStyle]="{
    height: buttonContent.height + 'px',
    width: buttonContent.width + 'px'
  }"
  [disabled]="disabled"
  [type]="buttonContent.submitBtn ? 'submit' : 'button'"
  fxLayoutAlign="center center"
>
  <img
    *ngIf="buttonContent.iconState === buttonIconStatus.Before"
    [ngStyle]="{
      height: buttonContent.iconHeight + 'px',
      'margin-right': buttonContent.imr + 'px'
    }"
    [src]="'assets/images/button/' + buttonContent.iconName + '.svg'"
    alt="iconBefore"
  />
  <ng-content></ng-content>
  <img
    *ngIf="buttonContent.iconState === buttonIconStatus.After"
    [ngStyle]="{
      height: buttonContent.iconHeight + 'px',
      'margin-left': buttonContent.iml + 'px'
    }"
    [src]="'assets/images/button/' + buttonContent.iconName + '.svg'"
    alt="iconAfter"
  />
</button>
